import script from "./TabbedRouterView.vue?vue&type=script&setup=true&lang=js"
export * from "./TabbedRouterView.vue?vue&type=script&setup=true&lang=js"

import "./TabbedRouterView.vue?vue&type=style&index=0&id=a9a7284a&lang=css"

const __exports__ = script;

export default __exports__